import { useCallback, useEffect, useState } from "react";

/**
 * Manages filter panel open state, focused field (chip → field scroll), and content offset class.
 */
export function useFilterPanel() {
  const [isOpen, setIsOpen] = useState(false);
  const [focusedFieldId, setFocusedFieldId] = useState(null);

  const open = useCallback((fieldId = null) => {
    setIsOpen(true);
    if (fieldId) setFocusedFieldId(fieldId);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setFocusedFieldId(null);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen((prev) => {
      if (prev) setFocusedFieldId(null);
      return !prev;
    });
  }, []);

  const focusField = useCallback((fieldId) => {
    setFocusedFieldId(fieldId);
    setIsOpen(true);
  }, []);

  const clearFocus = useCallback(() => {
    setFocusedFieldId(null);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, close]);

  const contentOffsetClass = isOpen ? "atlas-filter-content-offset" : "";

  return {
    isOpen,
    focusedFieldId,
    open,
    close,
    toggle,
    focusField,
    clearFocus,
    contentOffsetClass,
  };
}

export default useFilterPanel;
